import React from 'react';

const BS_Images = () => {
    return (
        <div>
            <h1>BS_Images Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Images;
